var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6683 15.2783C20.0321 16.7827 19.0371 18.1085 17.7702 19.1396C16.5033 20.1706 15.0031 20.8757 13.4007 21.193C11.7984 21.5104 10.1427 21.4304 8.57844 20.9601C7.01416 20.4897 5.58891 19.6433 4.42731 18.4949C3.2657 17.3465 2.4031 15.931 1.91492 14.3722C1.42674 12.8134 1.32785 11.1587 1.62689 9.5529C1.92592 7.94704 2.61378 6.43889 3.63033 5.16029C4.64688 3.88169 5.96117 2.87158 7.45829 2.21826",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4583 11.3882C21.4583 10.075 21.1997 8.7746 20.6971 7.56135C20.1946 6.34809 19.458 5.2457 18.5294 4.31712C17.6008 3.38853 16.4984 2.65194 15.2851 2.14939C14.0719 1.64684 12.7715 1.38818 11.4583 1.38818V11.3882H21.4583Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.372fadfaecf428561dbdd8f59527fbce.svg";
export { ForwardRef as ReactComponent };